import React, { useEffect, useState } from 'react';
import { Box, Button, Typography } from '@material-ui/core';
import { useIntl } from 'react-intl';
import { useSnackbar } from 'notistack';
import { useAptorApi } from '../../../../../Api';
import { SelectOption } from '../../../../../Components/Form/Form.types';
import Select from '../../../../../Components/Select/Select';
import { useStyles } from './ImpersonationRequestForm.styles';

export const ImpersonationRequestForm = ({ onSent }: { onSent?: () => void }) => {
  const classes = useStyles();
  const { api, abortController } = useAptorApi();
  const { formatMessage } = useIntl();
  const { enqueueSnackbar } = useSnackbar();
  const [users, setUsers] = useState<SelectOption[]>([]);
  const [userEmail, setUserEmail] = useState('');
  const [reason, setReason] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const selectedUser = users.find((user) => String(user.value) === userEmail) || null;

  useEffect(() => {
    api.getImpersonationUsers().then((result) => {
      if (!abortController.current.signal.aborted) setUsers(result.users);
    });
  }, [api, abortController]);

  const submit = async () => {
    setSubmitting(true);
    try {
      await api.createImpersonationRequest({ userEmail, reason: reason.trim() });
      enqueueSnackbar(formatMessage({ id: 'admin.impersonation-request.sent' }), { variant: 'success' });
      onSent?.();
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Box className={classes.form}>
      <Box className={classes.formGrid}>
        <Box className={classes.fieldGroup}>
          <Typography component="label" className={classes.fieldLabel} htmlFor="impersonation-user">
            {formatMessage({ id: 'admin.support.table.user' })}*
          </Typography>
          <Select
            className={classes.userSelect}
            selectProps={{
              inputId: 'impersonation-user',
              classNamePrefix: 'impersonation-user-select',
              options: users,
              value: selectedUser,
              placeholder: formatMessage({ id: 'utils.select.typeToSearch' }),
              isSearchable: true,
              isClearable: true,
              onChange: (option) => setUserEmail(option ? String((option as SelectOption).value) : ''),
            }}
          />
        </Box>
        <Box className={classes.fieldGroup}>
          <Typography component="label" className={classes.fieldLabel} htmlFor="impersonation-description">
            {formatMessage({ id: 'admin.support.table.description' })}*
          </Typography>
          <textarea
            id="impersonation-description"
            className={classes.description}
            rows={5}
            maxLength={1000}
            value={reason}
            onChange={(event) => setReason(event.target.value)}
            placeholder={formatMessage({ id: 'form.helpDescription' })}
          />
        </Box>
      </Box>
      <Box className={classes.footer}>
        <Button
          color="primary"
          variant="contained"
          disabled={!userEmail || !reason.trim() || submitting}
          onClick={submit}
        >
          {formatMessage({ id: 'form.invite' })}
        </Button>
      </Box>
    </Box>
  );
};
